import React, {useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Checkbox, Form, Input } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import { useWindowWidth } from '@react-hook/window-size';
import { serverFetch } from '../../server';
import { HtmlDescription } from '../../extensions/utils';

const isEmail = (v) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v || '');

const normalizeEmail = (v) => {
    let s = (v || '').toLowerCase().replace(/[^a-z0-9@._+-]/g, '');
    const at = s.indexOf('@');
    if (at >= 0) s = s.slice(0, at + 1) + s.slice(at + 1).replace(/@/g, '');
    return s;
};

const Certificate = ({ item, disabled, setCurrentItem, setCond, skipCommission }) => {
    const [form] = Form.useForm();
    const [sale, setSale] = useState();
    const [agreed, setAgreed] = useState(false);
    const [emailTouched, setEmailTouched] = useState(false);
    const [product, setProduct] = useState(null);
    const company = useSelector((s) => s.company);
    const user = useSelector((s) => s.user);
    const onlyWidth = useWindowWidth();
    const isMobile = onlyWidth < 744;

    useEffect(() => {
        // imageId уже установлен в catalog.js при загрузке productImages
        const imageId = item.imageId;
        let totalPrice = item.price;
        const commission = skipCommission ? 0 : Math.round(company && company.prcCommission > 0 ? totalPrice*company.prcCommission : 0)/100;
        totalPrice = totalPrice + commission;
        const sale = {
            receiverSendStatus: 0,
            productId: item.productId,
            qty: 1,
            price: item.price,
            totalPrice, 
            commission,
            imageId
        };
        form.setFieldsValue(sale);
        setSale(sale);
        setCurrentItem(sale);
    }, []);

    useEffect(() => {
        // Загружаем product
        if (item && item.productId) {
            serverFetch(`product/${item.productId}`, { method: 'GET' }, user)
                .then((data) => {
                    setProduct(data);
                })
                .catch((e) => {
                    console.log('Ошибка загрузки продукта:', e);
                });
        }
    }, [item, user]);
    
    useEffect(() => { setCond(isEmail(sale?.receiverEmail) && agreed); }, [sale?.receiverEmail, agreed, setCond]);

    const onValuesChange = (value) => {
        const newSale = { ...sale, ...value };
        setSale(newSale);
        setCurrentItem(newSale);
    };
    return (
        <>
            <div style={{ marginBottom: 8 }}><HtmlDescription value={product?.description} /></div>
            <Form colon={false} form={form} layout={isMobile ? 'vertical' : 'horizontal'} labelCol={isMobile ? undefined : { span: 7 }} wrapperCol={isMobile ? undefined : { span: 17 }} onValuesChange={onValuesChange}>
                {sale?.commission > 0 && (
                    <Form.Item label='Комиссия' name='commission' wrapperCol={{span: 6}}>
                        <Input size='middle' name='commission' disabled suffix='₽'/>
                    </Form.Item>
                )}
                <Form.Item label='Получатель' name='receiverName'>
                    <Input size='middle' name='receiverName' disabled={disabled} placeholder='Имя получателя'/>
                </Form.Item>
                <Form.Item
                    label='Эл. почта'
                    name='receiverEmail'
                    required
                    hasFeedback
                    normalize={normalizeEmail}
                    validateTrigger={emailTouched ? ['onChange', 'onBlur'] : 'onBlur'}
                    rules={[
                        { required: true, message: 'Без эл. почты мы не сможем отправить сертификат' },
                        { type: 'email', message: 'Похоже, в адресе опечатка — проверьте, пожалуйста' },
                    ]}
                    extra='На этот адрес отправим сертификат получателю'
                >
                    <Input disabled={disabled} placeholder='name@example.com' inputMode='email' autoComplete='email' onBlur={() => setEmailTouched(true)} />
                </Form.Item>
                <Form.Item label="Пожелание" name="Description"><TextArea /></Form.Item>
                <Form.Item label="Подпись" name="signText"><Input /></Form.Item>
            </Form>
            <Checkbox checked={agreed} onChange={(e) => setAgreed(e.target.checked)} style={{ fontSize: 12, marginTop: 8 }}>
                Нажимая кнопку «В корзину» или «Оплатить», я подтверждаю, что данные получателя указаны с его согласия, и даю согласие на обработку персональных данных в соответствии с <a href='/article/agreement' target='_blank' rel='noreferrer' onClick={(e) => e.stopPropagation()}>Политикой в отношении обработки персональных данных</a>
            </Checkbox>
        </>
    );
};

export default Certificate;
